import React, { useState, useEffect, useContext } from 'react'
import { styled } from '@mui/material/styles'
import Layout from '@/product/components/templates/Layout'
// import ErpAuction from './ErpAuction'
// import Inventory from './Inventory'
import Orders from './Orders'
import Location from './Location'
import PropTypes from 'prop-types'
import AppBar from '@mui/material/AppBar'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import './Schedule.css'
import { useHistory } from 'react-router-dom'
import OrderManager from './Orders/orderManage'
import { useLocation } from 'react-router-dom'
import ProductListView from '@/product/components/organisms/Product/ProductListView'
import AlertContext from '@/product/context/alert/alertContext'
import ScheduledPickupContext from '@/product/context/scheduledPickup/scheduledPickupContext'
import CustomDialog from '@/product/components/organisms/Dialog'
import InvoiceContext from '@/product/context/invoice/invoiceContext'
import SecondaryButton from '@/product/components/atoms/SecondaryButton'
import Message from '@/views/Message/index'
import {
    dateFormatFunction,
    dateTimeFormatFunction,
    currencyFormat,
    capitalize,
} from '@/custom/common/components'
import { Button, IconButton } from '@mui/material'
import { handleRedirectInternal } from '@/product/common/components'
import Customer from './Customer'
import moment from 'moment'
import Dashboard from './Dashboard'
import CustomInput from '@/product/components/atoms/Inputs/CustomInput'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'

const PREFIX = 'ERP'
let randomVariable = Math.random()

const classes = {
    root: `${PREFIX}-root`,
}

const StyledLayout = styled(Layout)(({ theme }) => ({
    [`& .${classes.root}`]: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
    },
}))

function TabPanel(props) {
    const { children, value, index, ...other } = props

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <div>{children}</div>}
        </div>
    )
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
}

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    }
}

const ERP = (props) => {
    const scheduledPickupContext = useContext(ScheduledPickupContext)
    const {
        getAllScheduledPickup,
        all_scheduled_pickup,
        schedule_data,
        getSchedulePickupTiming,
        schedulePickupAction,
        responseStatus,
        clearResponse,
    } = scheduledPickupContext
    const invoiceContext = useContext(InvoiceContext)
    const { single_invoice, getSingleInvoice } = invoiceContext
    const [scheduleData, setScheduleData] = useState([])
    const history = useHistory()
    const alertContext = useContext(AlertContext)
    const { setAlert } = alertContext
    const [value, setValue] = useState(1)
    const location = useLocation()
    const [events, setEvents] = useState([])
    const [allEventData, setAllEventData] = useState([])
    const [singleInvoice, setSingleInvoice] = useState(false)
    // const [handleNotesAdd, setHandleNotesAdd] = useState(false)
    // const [handleChatStatus, setHandleChatStatus] = useState(false)
    // const [handleVisitStatus, setHandleVisitStatus] = useState(false)
    // const [handleNotesActive, setHandleNotesActive] = useState(false)
    const [manage, setManage] = useState({
        popup: false,
        status: 'new',
        type: null,
    })

    let invId = props.match.params.id ? props.match.params.id : 0
    let [invoiceDetails, setInvoiceDetails] = useState({
        invoiceProducts: [],
        cartValues: {},
        appointmentDetail: {},
        locationDetail: {},
        invoiceTransactions: [],
        invoiceUser: [],
        invoiceAddress: [],
    })

    const slotDateFormat = (data) => {
        let formattedDate = ''
        if (data) {
            formattedDate = moment(data).format(
                global.dateFormat ? global.dateFormat : 'DD/MM/YYYY'
            )
        }
        return formattedDate
    }

    const slotTimeFormat = (data, meridian) => {
        let formattedDate = ''
        if (data) {
            if (meridian) {
                formattedDate = moment(data).format('hh:mm A')
            } else {
                formattedDate = moment(data).format('hh:mm')
            }
        }
        return formattedDate
    }

    const [handleActiveTabs, setHandleActiveTabs] = useState({
        handleNotesActive: false,
        handleVisitStatus: false,
        handleChatStatus: false,
        handleNotesAdd: false,
        handleNotes: false,
    })

    const handleNotesEdit = () => {
        setHandleActiveTabs({
            ...handleActiveTabs,
            handleNotesActive: !handleActiveTabs.handleNotesActive,
        })
    }

    const handleAddNotes = () => {
        setHandleActiveTabs({
            ...handleActiveTabs,
            handleNotesAdd: !handleActiveTabs.handleNotesAdd,
            handleNotesActive: false,
            handleVisitStatus: false,
            handleChatStatus: false,
            handleNotes: false,
        })
    }

    const handleVisitEntry = () => {
        setHandleActiveTabs({
            ...handleActiveTabs,
            handleVisitStatus: !handleActiveTabs.handleVisitStatus,
            handleNotesActive: false,
            handleChatStatus: false,
            handleNotesAdd: false,
            handleNotes: false,
        })
    }

    const handleUserChat = () => {
        setHandleActiveTabs({
            ...handleActiveTabs,
            handleChatStatus: !handleActiveTabs.handleChatStatus,
            handleNotesActive: false,
            handleVisitStatus: false,
            handleNotes: false,
            handleNotesAdd: false,
        })
    }

    const handleNotes = () => {
        setHandleActiveTabs({
            ...handleActiveTabs,
            handleNotes: !handleActiveTabs.handleNotes,
            handleNotesActive: false,
            handleVisitStatus: false,
            handleChatStatus: false,
            handleNotesAdd: false,
        })
    }

    useEffect(() => {
        getAllScheduledPickup(
            {
                limit: 20,
                page: 1,
                orderby: '',
                order: '',
                filters: {
                    status: {
                        type: 'in',
                        value: '',
                        field: 'schedule_status',
                    },
                    name: {
                        type: 'like',
                        value: '',
                        field: 'name',
                    },
                },
            },
            'calendarview'
        )
    }, [])

    const togglePopup = (popup, status, type) => {
        if (popup) {
            setManage({ popup, status, type })
        } else {
            setManage({ popup, status: 'new', type: null })
        }
    }

    const formik = useFormik({
        initialValues: {
            notes: '',
        },
        onSubmit: (values) => {},
    })

    const notestFields = [
        {
            label: 'Enter Notes',
            name: 'notes',
            type: 'textarea',
            placeholder: ``,
            class: '',
            size: 'large',
            autoFocus: false,
            formik: formik,
        },
    ]

    const spAddFields = [
        {
            label: 'Name',
            type: 'text',
            placeholder: 'Enter Nmae',
            class: 'col-12 p-0',
            name: 'name',
            formik: formik,
        },
        {
            label: 'Email',
            type: 'text',
            placeholder: 'Enter Email',
            class: 'col-12 p-0',
            name: 'email',
            formik: formik,
        },
        {
            label: 'Phone',
            type: 'text',
            placeholder: 'Enter Phone',
            class: 'col-12 p-0',
            name: 'phone',
            formik: formik,
        },
        {
            label: 'Location',
            type: 'select',
            placeholder: 'Select Location',
            class: 'col-12 p-0',
            name: 'location_id',
            formik: formik,
        },
        {
            label: 'Parking Lot',
            type: 'select',
            placeholder: 'Select Parking Lot',
            class: 'col-12 p-0',
            name: 'parking_lot_no',
            formik: formik,
            native: true,
        },
        {
            label: 'Invoice ID',
            type: 'text',
            placeholder: 'Enter Invoice ID',
            class: 'col-12 p-0',

            name: 'invoice_id',
            formik: formik,
        },
        {
            label: 'Start Date',
            type: 'datetime',
            placeholder: 'Enter Start Date',
            class: 'col-12 p-0',
            name: 'booking_start_date',
            formik: formik,
        },
        {
            label: 'End Date',
            type: 'datetime',
            placeholder: 'Enter End Date',
            class: 'col-12 p-0',
            name: 'booking_end_date',
            formik: formik,
        },
        {
            label: 'Notes',
            type: 'text',
            placeholder: 'Enter Notes',
            class: 'col-12 p-0',
            name: 'notes',
            formik: formik,
        },
    ]

    useEffect(() => {
        if (all_scheduled_pickup) {
            if (
                all_scheduled_pickup.records &&
                all_scheduled_pickup.records.length
            ) {
                if (all_scheduled_pickup.from == 'calendarview') {
                    let records = all_scheduled_pickup.records.map((record) => {
                        return {
                            id: record.id,
                            title: `${moment(record.booking_start_date).format(
                                'hh:mm A'
                            )} - ${record.name}`,
                            start: record.booking_start_date,
                            end: record.booking_end_date,
                        }
                    })
                    setAllEventData(all_scheduled_pickup.records)

                    setEvents(records.length ? records : [])
                }
            }
        }
    }, [all_scheduled_pickup])

    const handleChange = (event, newValue) => {
        if (newValue === 0) {
            setValue(newValue)
        } else if (newValue === 1) {
            setValue(newValue)
        } else if (newValue === 2) {
            setValue(newValue)
            getAllScheduledPickup(
                {
                    limit: 20,
                    page: 1,
                    orderby: '',
                    order: '',
                    filters: {
                        status: {
                            type: 'in',
                            value: '',
                            field: 'schedule_status',
                        },
                        name: {
                            type: 'like',
                            value: '',
                            field: 'name',
                        },
                    },
                },
                'calendarview'
            )
        } else if (newValue === 3) {
            setValue(newValue)
        } else if (newValue === 4) {
            setValue(newValue)
        } else if (newValue === 5) {
            setValue(newValue)
        }
    }

    const handleSingleInvoice = () => {
        setSingleInvoice(!singleInvoice)
    }

    useEffect(() => {
        if (responseStatus && responseStatus.from == 'popupSubmit') {
            if (responseStatus.status === 'success') {
                if (responseStatus.from == 'popupSubmit') {
                    setAlert('Successfully Added', responseStatus.status)
                    togglePopup(false, 'new', 'one')
                    getAllScheduledPickup(
                        {
                            limit: 20,
                            page: 1,
                            orderby: '',
                            order: '',
                            filters: {
                                status: {
                                    type: 'in',
                                    value: '',
                                    field: 'schedule_status',
                                },
                                name: {
                                    type: 'like',
                                    value: '',
                                    field: 'name',
                                },
                            },
                        },
                        'calendarview'
                    )
                }
            } else {
                setAlert(
                    responseStatus.message
                        ? responseStatus.message
                        : 'Internal server error',
                    'error'
                )
            }
            clearResponse()
        }
    }, [responseStatus])

    useEffect(() => {
        if (schedule_data && schedule_data.from == randomVariable) {
            if (schedule_data.records.length) {
                setScheduleData(schedule_data.records)
                handleSingleInvoice()
            } else {
                setScheduleData([])
            }
        } else {
            setSingleInvoice(false)
        }
    }, [schedule_data])

    const customEventContent = (eventInfo) => {
        const eventId = eventInfo.event._def.publicId
        const matchedEvent = allEventData.filter((data) => data.id == eventId)
        const scheduleStatus = matchedEvent
            ? matchedEvent[0].schedule_status
            : 'Status not found'
        const getBackgroundColor = () => {
            switch (scheduleStatus) {
                case 'booking':
                    return '#ff9900'
                case 'waiting':
                    return '#ffcc00'
                case 'serving':
                    return '#0073e6'
                case 'completed':
                    return '#009933'

                default:
                    return '#f0f0f0'
            }
        }
        return (
            <>
                <div
                    style={{
                        background: getBackgroundColor(),
                        padding: '4px 4px',
                        borderRadius: '4px',
                    }}
                    className="cursorDecoy"
                >
                    {eventInfo.event.title}
                </div>
            </>
        )
    }

    const handleEventClick = (info) => {
        const eventId = info.event.id
        let invoiceId = allEventData.filter((data) => data.id == eventId)

        if (invoiceId.length) {
            randomVariable = Math.random()
            getSchedulePickupTiming(
                {
                    limit: 12,
                    page: 1,
                    orderby: 'p.date_closed,asc',
                    order: '',
                    scheduled: 1,
                    admin: true,
                    filters: {
                        invoice_id: {
                            value: invoiceId[0].invoice_id,
                            type: 'in',
                            field: 'b.common_invoice',
                        },
                    },
                    action: 'won',
                },
                randomVariable
            )
            getSingleInvoice(
                {
                    invoice_id: invoiceId[0].invoice_id,
                    user_id: invoiceId[0].user_id,
                },
                'viewInvoice'
            )
        }
        // props.function(true, 'edit', eventId)
    }

    const handleDateClick = (arg) => {
        togglePopup(true, 'new', 'one')
    }

    const submitPopupFunction = (values) => {
        let dateFields = ['booking_start_date', 'booking_end_date']
        let newObj = { ...values }
        dateFields.map((ele) => {
            newObj[ele] = moment(
                dateTimeFormatFunction(newObj[ele] ? newObj[ele] : new Date()),
                'MM-DD-YYYY h:mm a'
            ).format()
        })

        schedulePickupAction(newObj, 'popupSubmit')
    }

    useEffect(() => {
        if (single_invoice && single_invoice.from === 'viewInvoice') {
            setInvoiceDetails({
                invoiceProducts: single_invoice.invoicerecords.length
                    ? single_invoice.invoicerecords
                    : [],
                cartValues: single_invoice.cartvalues,
                appointmentDetail: single_invoice.appointmentrecord,
                locationDetail: single_invoice.locationrecord,
                invoiceTransactions: single_invoice.transactionrecords,
                invoiceUser: single_invoice.invoiceuserrecord,
                invoiceAddress: single_invoice.invoiceaddressrecord,
            })
        }
    }, [single_invoice])

    return (
        <StyledLayout
            noUI={props.noUI || false}
            renderSidePanelDefault={props.renderSidePanelDefault || false}
        >
            <div className="">
                <AppBar position="static" className="scheduleTabs">
                    <Tabs
                        value={value}
                        onChange={handleChange}
                        variant="fullWidth"
                        aria-label="ERP Tabs"
                    >
                        <Tab
                            className="dashIcon"
                            label={
                                <span className="material-icons">
                                    dashboard
                                </span>
                            }
                            {...a11yProps(0)}
                        />
                        <Tab label="Orders" {...a11yProps(1)} />
                        <Tab label="Schedule Calendar" {...a11yProps(2)} />
                        <Tab label="Message" {...a11yProps(3)} />
                        <Tab label="Customers" {...a11yProps(4)} />
                        <Tab label="Settings" {...a11yProps(5)} />
                    </Tabs>
                </AppBar>
                <TabPanel value={value} index={0}>
                    <Dashboard invId={invId} />
                </TabPanel>
                <TabPanel value={value} index={1}>
                    <Orders invId={invId} />
                </TabPanel>
                <TabPanel value={value} index={2}>
                    <div className="calendarAuctions">
                        <FullCalendar
                            plugins={[
                                dayGridPlugin,
                                timeGridPlugin,
                                interactionPlugin,
                            ]}
                            headerToolbar={{
                                left: 'prev,next today',
                                center: 'title',
                                right: 'dayGridMonth',
                            }}
                            initialView="dayGridMonth"
                            editable={false}
                            selectable={true}
                            selectMirror={true}
                            dayMaxEvents={1}
                            initialEvents={events}
                            eventContent={customEventContent}
                            eventClick={handleEventClick}
                            dateClick={handleDateClick}
                            moreLinkContent={(arg) => {
                                if (arg.num > 1) {
                                    return `+${arg.num} ${
                                        arg.num === 1 ? 'pickup' : 'pickups'
                                    }`
                                }
                                return ''
                            }}
                        />
                    </div>
                </TabPanel>
                <TabPanel value={value} index={3}>
                    <Message className="scheduleMsgCnt" />
                </TabPanel>
                <TabPanel value={value} index={4}>
                    <Customer />
                </TabPanel>
                <TabPanel value={value} index={5}>
                    <Location noLayout={true} />
                </TabPanel>
            </div>
            <OrderManager
                data={manage}
                function={togglePopup}
                submitFunction={submitPopupFunction}
            />
            <CustomDialog
                className="singleInvcRoot"
                open={singleInvoice}
                function={handleSingleInvoice}
                maxWidth="xl"
            >
                <div className="cusHeader d-flex align-items-center justify-content-between flex-wrap">
                    <div className="cusSide">
                        Invoice #{scheduleData[0]?.common_invoice}{' '}
                        <span className="ml-3">
                            {scheduleData.length} items
                        </span>
                    </div>
                    <div className="cusBody">
                        <span className="mr-3 inStatus">
                            <i className="material-icons mr-1">
                                fiber_manual_record
                            </i>
                            Status
                        </span>
                        <span className="mr-3 inBdge">
                            {capitalize(
                                scheduleData[0]?.schedulepickup_schedule_status
                            )}
                        </span>
                        <IconButton onClick={handleSingleInvoice}>
                            <span className="material-icons-outlined me-2">
                                close
                            </span>
                        </IconButton>
                    </div>
                </div>
                <div className="invBdyElementRoot">
                    <div className="invChildLftElement">
                        <div className="cusDetls mb-4">
                            <label>
                                {scheduleData[0]?.users_first_name}{' '}
                                {scheduleData[0]?.users_last_name}
                            </label>
                            <div className="cusDetlsLst">
                                <span>
                                    {scheduleData[0]?.users_first_name}{' '}
                                    {scheduleData[0]?.users_last_name}
                                </span>
                                <span>
                                    <i className="material-icons-outlined mr-2">
                                        mail
                                    </i>
                                    {scheduleData[0]?.users_email}
                                </span>
                                <span>
                                    <i className="material-icons-outlined mr-2">
                                        call
                                    </i>
                                    {scheduleData[0]?.users_phone}
                                </span>
                            </div>
                        </div>
                        <div className="slotDetls mb-4">
                            <div className="slotDetlsLst">
                                <label>Ticket ID</label>
                                <span>1713783872</span>
                            </div>
                            <div className="slotDetlsLst">
                                <label>Notes</label>
                                <span>
                                    <Button
                                        size="small"
                                        color="secondary"
                                        className="p-0 text-capitalize"
                                        onClick={handleAddNotes}
                                    >
                                        Add Notes
                                    </Button>
                                </span>
                            </div>
                            <div className="slotDetlsLst">
                                <label>Order created</label>
                                <span>
                                    {dateTimeFormatFunction(
                                        scheduleData[0]?.buynow_date_added
                                    )}
                                </span>
                            </div>
                            <div className="slotDetlsLst">
                                <label>Pick up slot</label>
                                <span>
                                    {slotDateFormat(
                                        scheduleData[0]
                                            ?.schedulepickup_booking_start_date
                                    )}{' '}
                                    at{' '}
                                    {slotTimeFormat(
                                        scheduleData[0]
                                            ?.schedulepickup_booking_start_date,
                                        false
                                    )}{' '}
                                    -{' '}
                                    {slotTimeFormat(
                                        scheduleData[0]
                                            ?.schedulepickup_booking_end_date,
                                        true
                                    )}
                                </span>
                            </div>
                        </div>
                        <div className="invoiceCard">
                            <div className="table-responsive">
                                <table className="w-100">
                                    <thead>
                                        <tr>
                                            <th>Items</th>
                                            <th>Qty</th>
                                            <th>Total</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {scheduleData.map((data) => (
                                            <tr>
                                                <>
                                                    <td>{data.title}</td>
                                                    <td>{data.qty}</td>
                                                    <td>
                                                        ${data.buynowamount}
                                                    </td>
                                                </>
                                            </tr>
                                        ))}
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <td></td>
                                            <td>Before tax</td>
                                            <td>
                                                {currencyFormat(
                                                    invoiceDetails.cartValues
                                                        .per_total
                                                )}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td></td>
                                            <td>Sales tax</td>
                                            <td>
                                                {currencyFormat(
                                                    invoiceDetails.cartValues
                                                        .total_tax
                                                )}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td></td>
                                            <td>Total</td>
                                            <td>
                                                {currencyFormat(
                                                    scheduleData[0]
                                                        ?.buynow_total_invoice
                                                )}
                                            </td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div className="invChildRgtElement">
                        <div className="invBtnGrp d-flex align-items-center mb-4">
                            <SecondaryButton
                                btnSize="mr-3 small"
                                onClick={() => {
                                    handleRedirectInternal(
                                        history,
                                        `invoice/view/${scheduleData[0]?.common_invoice}/${scheduleData[0]?.buynow_user_id}`
                                    )
                                    handleSingleInvoice()
                                }}
                            >
                                View invoice
                            </SecondaryButton>
                            {/* <SecondaryButton btnSize="mr-3 small">
                                <i className="material-icons-outlined">
                                    chat_bubble_outlined
                                </i>
                                Message customer
                            </SecondaryButton> */}
                        </div>
                        <div className="invNotes">
                            <div className="ntsRootElement">
                                <div className="ntsHdr">
                                    <div className="tit">Notes</div>
                                    {/* <Button onClick={() => handleNotes()}>Add</Button> */}
                                </div>
                                <p>{scheduleData[0]?.schedulepickup_notes}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </CustomDialog>
        </StyledLayout>
    )
}

export default ERP
